import { Node } from 'tiptap'
import { chainCommands, exitCode } from 'tiptap-commands'

export default class Text extends Node {

  get name() {
    return 'pasteText'
  }

  get schema() {
    return {
      attrs: {
        text: {
          default: null,
        },
      },
      group: 'inline*',
    }
  }

  commands({ type }) {
    return {
      pasteText: attrs => (state, dispatch) => {
        const { selection } = state
        const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
        dispatch(state.tr.insertText(attrs.text,position))
      },
    }
  }

}
